// frontend/js/languageSwitcher.js
(function() {
    function initI18n(options = {}) {
        if (window.__STATIC_TRANSLATIONS__) window.i18n.init({
            initialLang: options.initialLang
        });
        else if (window.__LOCALE_LOADER__) window.i18n.init({
            initialLang: options.initialLang,
            loader: window.__LOCALE_LOADER__
        });
        const select = document.querySelector("#langSelect");
        if (select) select.addEventListener("change", (e)=>window.i18n.setLanguage(e.target.value));
    }
    window.languageSwitcher = {
        initI18n,
        EVENT_NAME: "languagechange"
    };
})();

//# sourceMappingURL=bondTransaction.ef6acaf0.js.map
